import React from "react";
import VerifyYou from "../components/AuthPages/VerifyYou";

export default function VerifyYouPages() {
  return <VerifyYou />;
}
